var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4 18.8247C4.02746 18.3494 4.17158 17.8674 4.45273 17.4156L5.95545 15.0005H18.0405L19.5418 17.4176C20.783 19.416 19.3459 22.0005 16.9934 22.0005H6.99989C5.30552 22.0005 4.0862 20.66 4 19.1634V18.8247Z",
    fill: "#A461D8",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 7.00049H16C16.5523 7.00049 17 7.4482 17 8.00049C17 8.55277 16.5523 9.00049 16 9.00049H15.9999V11.4299C15.9999 11.6164 16.052 11.7991 16.1504 11.9575L19.5418 17.4176C20.783 19.416 19.3459 22.0005 16.9934 22.0005H6.99989C4.64628 22.0005 3.20931 19.4139 4.45273 17.4156L7.84896 11.9574C7.94761 11.7988 7.9999 11.6158 7.9999 11.4291V9.00049C7.44766 9.00044 6.99999 8.55274 6.99999 8.00049C6.99999 7.44823 7.44766 7.00054 7.9999 7.00049C7.99993 7.00049 7.99996 7.00049 7.99999 7.00049H8.9999H14.9999H15.9999ZM9.9999 9.00049V11.4291C9.9999 11.9893 9.84304 12.5383 9.54707 13.014L6.15084 18.4722C5.73637 19.1383 6.21536 20.0005 6.99989 20.0005H16.9934C17.7775 20.0005 18.2566 19.139 17.8428 18.4729L14.4515 13.0128C14.1563 12.5376 13.9999 11.9893 13.9999 11.4299V9.00049H9.9999Z",
    fill: "#A461D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.00049C14.5523 4.00049 15 3.55277 15 3.00049C15 2.4482 14.5523 2.00049 14 2.00049C13.4477 2.00049 13 2.4482 13 3.00049C13 3.55277 13.4477 4.00049 14 4.00049ZM10 5.00049C10.5523 5.00049 11 4.55277 11 4.00049C11 3.4482 10.5523 3.00049 10 3.00049C9.44772 3.00049 9 3.4482 9 4.00049C9 4.55277 9.44772 5.00049 10 5.00049Z",
    fill: "#A461D8",
    fillOpacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab);
export default __webpack_public_path__ + "static/media/Lab.fd02efd15c841d81d8d73506a42170c9.svg";
export { ForwardRef as ReactComponent };